// node_modules
import axios, { AxiosResponse } from "axios";
// Helpers
import { AxiosHelperSingleton } from "Helpers";
// Types
import { TAuthDTO } from "Types";

export class AuthController {
    public async getAsync(): Promise<TAuthDTO | undefined> {
        try {
            const response: AxiosResponse<TAuthDTO> = await axios.get<TAuthDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/auth`);
            if (response && response.data) {
                AxiosHelperSingleton.setCommonHeaderConfigDefaults("RequestVerificationToken", response.data.antiForgeryToken);
                return response.data;
            } else {
                return undefined;
            }
        } catch {
            return undefined;
        }
    }
}

export const AuthControllerSingleton = new AuthController();
